import App from './app.svelte'
import SearchApp from './searchwidget.svelte'

export function hydrateApp(el, props) {
  return new App({
    target: el,
    hydrate: true,
    props,
  })
}

export function hydrateSearchApp(el, props) {
  return new SearchApp({
    target: el,
    hydrate: true,
    props,
  })
}
